import axios from '@/services/httpSetup';

let pending = null;

export function checkAdminSession() {
  if (pending) return pending;

  pending = axios.get('/api/login/verify')
    .then(() => true)
    .catch(() => false);

  pending.finally(() => {
    setTimeout(() => {
      pending = null;
    }, 3000);
  });

  return pending;
}
